//call and export all env details here

export const appName = process.env.REACT_APP_NAME;
export const apiKey = process.env.REACT_APP_API_KEY;
export const portalId = process.env.REACT_APP_PORTAL_ID;
export const formId = process.env.REACT_APP_FORM_ID;
